import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import { OutlinedButton } from '@prisjakt/ui/button/variants';

export const ToplistLink = styled.a`
  color: ${p => p.theme.colors.maybeBlue700};
`;

export const FeaturedCategoryArticle = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;

  h3 {
    font-weight: bold;
    margin-bottom: 0;
  }
`;

export const ArticleLink = styled(OutlinedButton)`
  ${media.smallOnly`
    width: 100%;
  `};
`;

export const TextContainer = styled.div``;

export const ImageWrapper = styled.div`
  overflow: hidden;
  border-radius: ${layout.measurements.spacing100};
  position: relative;
  margin: ${layout.measurements.spacing100} 0;
  min-height: 170px;
  max-height: 250px;

  img {
    width: 100%;
  }
`;
